import { assign } from 'xstate5';

import { type LocationSearchMachineAction } from '../../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const onPickup: LocationSearchMachineAction = assign({
  locationSearchType: () => 'pickup' as const,
});

export const onDelivery: LocationSearchMachineAction = assign({
  locationSearchType: () => 'delivery' as const,
});

export const onOutpost: LocationSearchMachineAction = assign({
  locationSearchType: () => 'outpost' as const,
});
